import {useState,useEffect, useContext} from 'react'
import {Helmet} from "react-helmet";
import React, {Component} from "react";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NavigationMenuToggle from '../../Components/Navigation/NavigationMenuToggle'
import {Link} from 'react-router-dom';
import {useNavigate} from "react-router-dom";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import Button from '@mui/material/Button';
import ValidateUser from '../../Components/UserCredentials/ValidateUser';
import { GeneralFunctionsContext } from '../../Components/Contexts/GeneralFunctionsContext';
export default function Earnings () {
    const navigate = useNavigate();
    const {innerWidth, offset} = useContext(GeneralFunctionsContext);
    useEffect(()=>{
        window.scrollTo(0, 0)
    },[])


    return (
        <>
        <ValidateUser/>
        <Helmet>
            <title>Earnings</title>
            <meta property="og:title" content="Settings" />
            <meta name="title" content="Settings"/>
            <meta name="description" content="Settings"/>
            <meta property="og:image" content="/assets/images/geniux_music_logo.png"/>
        </Helmet>
        
        <>
        <div className='has-hero-banner'>
            
             <div className={offset > 20 ? "navbar active" : "navbar"}>
                <div className="wrapper">
                    <div className="lft">
                        <IconButton className="icon" onClick={()=> navigate(-1)}>
                            <ArrowBackIcon />
                        </IconButton> 
                        <div className="titles">
                            <p>EARNINGS</p>
                        </div>
                    
                    </div>
                    <div className="rgt">
                        <NavigationMenuToggle/>
                    </div>
                </div>
            </div> 
            
            
            <div className="mycontainer">
                <div className="hero-banner">
                    <div className="background">
                        <img src="/assets/images/geniux-music-banner-desktop-slide-1.jpg?geniuxmusic" className="bg-image"/>
                        <div className="bg-fade"></div>
                    </div>
                    {/* My  path */}
                    {/* {innerWidth>992 &&(
                        <div className="mypath">
                            <div className="wrapper">
                                <div className="lft">
                                    {window.history.length>1?
                                    <Button onClick={()=>navigate(-1)}>
                                        <KeyboardBackspaceIcon/>
                                    </Button>  
                                    :
                                    <Button onClick={()=>navigate(-1)} disabled="true">
                                        <KeyboardBackspaceIcon/>
                                    </Button>  
                                    }
                                </div>
                                <div className="rgt">
                                    <p>
                                        <Link to="/settings" className="active">EARNINGS</Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    )} */}
                </div>
               
                <div className="wrapper">
                    <br/>
                    <div className="htitle">
                        <div className="lft"><p>Start Earning Like a Pro</p></div>
                    </div>
                    <p>
                        Welcome to Earnings. The revolutionary music streaming platform where value flows to everyone. We believe that music should reward not only the creators but also the community that powers it. <br/><br/>
                        On Earnings, artists earn fairly from every stream, and for the first time ever, listeners get rewarded too.<br/><br/>
                        
                        But Earnings is more than just streaming, it’s a space where you can support and discover new, upcoming artists, helping fresh talent grow and 
                        thrive. Whether you’re creating, exploring, or sharing music, you’re part of a community that truly gives back.<br/><br/>
                    </p>

                    <div className="htitle">
                        <div className="lft"><p>Join us by selecting the package that suits you best.</p></div>
                    </div>

                    

                    <div className='row'>
                        <div className="col-12 col-lg-4">
                            <Link to="/earnings/artists">
                                <Button variant='outlined' color='secondary' className={innerWidth < 992 ? 'package-card active' : 'package-card'} slide="1">
                                    <div class="price-badge">
                                        <p class="current-price">R379.99/year</p>
                                        <p class="old-price">R779.99/year</p>
                                    </div>
                                    <div className='background'>
                                        <img src="/assets/images/earnings-slide-2.jpg" className='bg-image'/>
                                        <div className='bg-fade'></div>
                                    </div>
                                    <div className='contain'>
                                        <div className="details">
                                            <div className='title'>
                                                <p><span>Earn</span> from your songs</p>
                                                <p>For artists</p>
                                            </div>
                                            <div className='list'>
                                                <p>Real-Time Earnings</p>
                                                <p>Detailed Analytics</p>
                                                <p>Royalty-Based Payouts</p>
                                                <p>Artist Wallet</p>
                                                <p>Promotion Tools</p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </Button>
                            </Link>
                            
                        </div>
                        <div className="col-12 col-lg-4">
                            <Link to="/earnings/fans">
                                <Button variant='outlined' color='secondary' className={innerWidth < 992 ? 'package-card active' : 'package-card'} slide="2">
                                    <div class="price-badge">
                                        <p class="current-price">R579.99/year</p>
                                        <p class="old-price">R979.99/year</p>
                                    </div>
                                    <div className='background'>
                                        <img src="/assets/images/earnings-slide-1.jpg" className='bg-image'/>
                                        <div className='bg-fade'></div>
                                    </div>
                                    <div className='contain'>
                                        <div className="details">
                                            <div className='title'>
                                                <p><span>Earn</span> by listening</p>
                                                <p>For listeners</p>
                                            </div>
                                            <div className='list'>
                                                <p>Live Earnings</p>
                                                <p>Listening Stats</p>
                                                <p>Stream-Based Rewards</p>
                                                <p>Secure Wallet</p>
                                                <p>Discover & Earn</p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </Button>
                            </Link>
                        </div>
                        <div className="col-12 col-lg-4">
                            <Button variant='outlined' color='secondary' className={innerWidth < 992 ? 'package-card active' : 'package-card'} slide="3">
                                <div class="price-badge">
                                    <p class="current-price">R779.99/year</p>
                                    <p class="old-price">R1579.99/year</p>
                                </div>
                                <div className='background'>
                                    <img src="/assets/images/earnings-slide-3.jpg" className='bg-image'/>
                                    <div className='bg-fade'></div>
                                </div>
                                <div className='contain'>
                                    <div className="details">
                                        <div className='title'>
                                            <p><span>Become</span> a manager </p>
                                            <p>For listeners</p>
                                        </div>
                                        <div className='list'>
                                            <p>Stream-Based Earnings</p>
                                            <p>Stream-Based Earnings</p>
                                            <p>Stream-Based Earnings</p>
                                            <p>Stream-Based Earnings</p>
                                            <p>Stream-Based Earnings</p>
                                        </div>
                                    </div>
                                </div>
                                
                            </Button>
                        </div>
                        

                    </div>
                </div>
            </div>
        </div>
        </>

        
        </>
    )
}



